<template>
  <section id="steps">
    <div
      class="step"
      :class="{active: step >= 1}"
    >
      <div class="number">
        1
      </div>
      <span>{{ $t('cart') }}</span>
    </div>
    <div
      class="step"
      :class="{active: step >= 2}"
    >
      <div class="number">
        2
      </div>
      <span>{{ $t('Delivery data') }}</span>
    </div>
    <div
      class="step"
      :class="{active: step >= 3}"
    >
      <div class="number">
        3
      </div>
      <span>{{ $t('Shipping and payment') }}</span>
    </div>
    <div
      class="step"
      :class="{active: step >= 4}"
    >
      <div class="number">
        4
      </div>
      <span>{{ $t('Summary') }}</span>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      step: 'cart/getStep',
    }),
  },
}
</script>
